import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {InventoryStockSizeSingleSelectEditControlComponent} from "./inventory/controls/inventory-stock-size-single-select-edit-control.component";
import {FrameworkModule} from "../framework/framework.module";
import {InventorySingleSelectEditControlComponent} from "./inventory/controls/inventory-single-select-edit-control.component";
import {InventoryMultiSelectSearchControlComponent} from "./inventory/controls/inventory-multi-select-search-control.component";
import {InventoryGroupSingleSelectEditControlComponent} from "./inventory-group-search-page/controls/inventory-group-single-select-edit-control.component";
import {ManufacturerSingleSelectEditControlComponent} from "./manufacturer/controls/manufacturer-single-select-edit-control.component";
import {SupplierSingleSelectEditControlComponent} from "./supplier/controls/supplier-single-select-edit-control.component";
import {InventoryReportSelectionControlComponent} from "./inventory/controls/inventory-report-selection-control.component";
import {StockCostingTypeSingleSelectEditControlComponent} from "./costing/controls/stock-costing-type-single-select-edit-control.component";
import {StockCostingHeaderComponent} from "./costing/controls/stock-costing-header.component";
import {PosSharedModule} from "../pos/pos.shared.module";
import {InventoryStockSizeSingleSelectColumnComponent} from "./inventory/controls/inventory-stock-size-single-select-column.component";
import {SupplierReportSelectionControlComponent} from "./supplier/controls/supplier-report-selection-control.component";
import {InventoryBarcodeReportSelectionControlComponent} from "./inventory-barcode/controls/inventory-barcode-report-selection-control.component";
import {InventoryBarcodeSingleSelectEditControlComponent} from "./inventory-barcode/controls/inventory-barcode-single-select-edit-control.component";
import {StockTakeSingleSelectEditControl} from "./stock-take/controls/stock-take-single-select-edit-control.component";
import {StockMovementMultiSelectEditControlComponent} from "./movement/controls/stock-movement-multi-select-edit-control.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        PosSharedModule
    ],
    declarations: [
        InventoryStockSizeSingleSelectEditControlComponent,
        InventoryStockSizeSingleSelectColumnComponent,
        InventorySingleSelectEditControlComponent,
        InventoryMultiSelectSearchControlComponent,
        InventoryGroupSingleSelectEditControlComponent,
        ManufacturerSingleSelectEditControlComponent,
        SupplierSingleSelectEditControlComponent,
        SupplierReportSelectionControlComponent,
        InventoryReportSelectionControlComponent,
        InventoryBarcodeReportSelectionControlComponent,
        InventoryBarcodeSingleSelectEditControlComponent,
        StockCostingTypeSingleSelectEditControlComponent,
        StockCostingHeaderComponent,
        StockTakeSingleSelectEditControl,
        StockMovementMultiSelectEditControlComponent
    ],
    exports: [
        InventoryStockSizeSingleSelectEditControlComponent,
        InventoryStockSizeSingleSelectColumnComponent,
        InventorySingleSelectEditControlComponent,
        InventoryMultiSelectSearchControlComponent,
        InventoryGroupSingleSelectEditControlComponent,
        ManufacturerSingleSelectEditControlComponent,
        SupplierSingleSelectEditControlComponent,
        SupplierReportSelectionControlComponent,
        InventoryReportSelectionControlComponent,
        InventoryBarcodeReportSelectionControlComponent,
        InventoryBarcodeSingleSelectEditControlComponent,
        StockCostingTypeSingleSelectEditControlComponent,
        StockCostingHeaderComponent,
        StockTakeSingleSelectEditControl,
        StockMovementMultiSelectEditControlComponent
    ]
})
export class StockSharedModule {
}
